import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors3';

export const CardPreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: ${SPACING.S24};

  ${MEDIA_QUERY.MOBILE} {
    padding: ${SPACING.S16} ${SPACING.SM};
  }
`;

export const LinkWrapper = styled.a`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  margin-bottom: ${SPACING.XS};

  &:hover,
  &:focus {
    text-decoration: none;
    p {
      text-decoration: underline;
    }
  }
`;

export const CardImageWrapper = styled.div`
  display: block;
  position: relative;
  align-self: center;
  width: 133px;
  height: 133px;

  ${MEDIA_QUERY.TABLET} {
    width: 182px;
    height: 182px;
  }
  ${MEDIA_QUERY.DESKTOP} {
    width: 226px;
    height: 226px;
  }

  ${MEDIA_QUERY.DESKTOP_LG} {
    width: 272px;
    height: 272px;
  }
`;

export const CardImage = styled.img`
  align-self: center;
  max-width: 133px;

  ${MEDIA_QUERY.TABLET} {
    max-width: 182px;
  }
  ${MEDIA_QUERY.DESKTOP} {
    max-width: 226px;
  }

  ${MEDIA_QUERY.DESKTOP_LG} {
    max-width: 272px;
  }
`;

export const NameWrapper = styled.div`
  margin-top: ${SPACING.SM};
  display: flex;
  column-gap: ${SPACING.XS};
  align-items: center;

  ${MEDIA_QUERY.MOBILE} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Name = styled.p`
  margin: 0;
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  font-size: ${FONT.FONT_SIZE_SMALLER};

  ${MEDIA_QUERY.DESKTOP} {
    font-weight: ${FONT.FONT_WEIGHT_BOLD};
    font-size: ${FONT.FONT_SIZE_SMALL};
  }
`;

export const ProductColorPicker = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  position: relative;

  a {
    margin-left: ${SPACING.XXS};
  }
`;

export const ColorWrapper = styled.button<{ active: boolean }>`
  border: 1px solid transparent;
  border-radius: 50%;
  display: inline-block;
  padding: 3px;
  position: relative;
  background: none;
  outline: revert;

  ${props =>
    props.active &&
    css`
      border-color: ${COLORS.BLACK_100};
    `};

  .tooltip__container {
    position: absolute;
    border: 0;
    bottom: 33px;
    right: -52px;
    opacity: 0;
    pointer-events: none;
  }

  &:hover,
  &:focus {
    .tooltip__container {
      opacity: 1;
    }
  }
`;

export const Color = styled.div<{ rainbow?: boolean }>`
  border: 1px solid #c0c0c0;
  border-radius: 50%;
  cursor: pointer;
  display: block;

  ${props =>
    props.rainbow &&
    css`
      background: radial-gradient(50% 50% at 50% 50%, #fff 0%, rgba(255, 255, 255, 0) 100%),
        conic-gradient(
          from -90deg at 50% 50%,
          #c0f -3.06deg,
          #f00 21.31deg,
          #f90 56.93deg,
          #ffe600 105.68deg,
          #fff500 141.31deg,
          #3f0 186.31deg,
          #0ff 236.94deg,
          #00f7ff 250.06deg,
          #000aff 293.19deg,
          #c0f 356.94deg,
          #f00 381.31deg
        );
    `};
`;

export const Price = styled.p`
  align-self: flex-start;
  margin-top: ${SPACING.S32};

  ${MEDIA_QUERY.MOBILE} {
    font-size: ${FONT.FONT_SIZE_SMALLER};
  }
`;
